module.exports = __webpack_public_path__ + "fonts/Raleway-Bold.798e56bf.woff2";